<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Avaliações de Desempenho</h5>
    </div>

    <!-- Filtros -->
    <div class="d-flex mb-3" style="gap: 10px;">
      <input
        v-model="filters.avaliacao"
        placeholder="Filtrar por Avaliação"
        class="form-control"
        @input="filtrarAvaliacoes"
      />

      <input
        v-model="filters.aluno"
        placeholder="Filtrar por Aluno"
        class="form-control"
        @input="filtrarAvaliacoes"
      />
      <input
        v-model="filters.instrutor"
        placeholder="Filtrar por Instrutor"
        class="form-control"
        @input="filtrarAvaliacoes"
      />
      <input
        v-model="filters.turma"
        placeholder="Filtrar por Turma"
        class="form-control"
        @input="filtrarAvaliacoes"
      />

      <!-- NOVO: Filtro de Vigência -->
      <b-form-select
        v-model="filters.vigencia"
        :options="vigenciaOptions"
        class="form-control w-auto"
        @change="filtrarAvaliacoes"
      />
      <!-- NOVO: Filtro de Realização -->
      <b-form-select
        v-model="filters.realizacao"
        :options="realizacaoOptions"
        class="form-control w-auto"
        @change="filtrarAvaliacoes"
      />

      <b-button
        variant="secondary"
        @click="limparFiltros"
        class="d-flex align-items-center justify-content-center"
      >
        <i class="bi bi-funnel mr-2" title="Limpar Filtros"></i>
      </b-button>
    </div>

    <!-- Tabela customizada para ordenar colunas -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            <button class="btn btn-link p-0" @click="sort('id')">
              ID {{ arrow('id') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('avaliacao')">
              Avaliação {{ arrow('avaliacao') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('aluno')">
              Aluno {{ arrow('aluno') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('instrutor')">
              Instrutor {{ arrow('instrutor') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('turma')">
              Turma {{ arrow('turma') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data_limite')">
              Data Limite {{ arrow('data_limite') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('realizada')">
              Realizada {{ arrow('realizada') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data')">
              Data {{ arrow('data') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('submetida')">
              Submetida {{ arrow('submetida') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data_submissao')">
              Data Submissão {{ arrow('data_submissao') }}
            </button>
          </th>
          <th class="text-end">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in avaliacoesDesempenho" :key="row.id">
          <td>{{ row.id }}</td>
          <td>{{ row.avaliacao }}</td>
          <td>{{ row.aluno }}</td>
          <td>{{ row.instrutor }}</td>
          <td>{{ row.turma }}</td>
          <td>{{ row.data_limite }}</td>
          <td>{{ row.realizada }}</td>
          <td>{{ row.data }}</td>
          <td>{{ row.submetida }}</td>
          <td>{{ row.data_submissao }}</td>
          <td class="text-end">
            <!-- Ações: Realizar / Avaliar / Editar / Submeter / Finalizada -->
            <i
              v-if="row.realizada !== 'Sim'"
              class="bi bi-pencil-square text-info mx-1"
              title="Realizar Prova"
              @click="abrirRealizarProva(row)"
            ></i>
            <i
              v-if="row.can_analisar && row.submetida === 'Sim' && row.finalizada === 'Não'"
              class="bi bi-star text-primary mx-2"
              title="Analisar Avaliação"
              @click="abrirAvaliarProva(row)"
            ></i>
            <i
              v-if="row.realizada==='Sim' && row.submetida==='Não'"
              :class="row.reavaliar==='Sim' ? 'bi bi-pencil-square text-danger mx-1' : 'bi bi-pencil-square text-warning mx-1'"
              title="Editar Prova"
              @click="abrirRealizarProva(row)"
            ></i>
            <i
              v-if="row.submetida==='Não' && row.realizada==='Sim'"
              class="bi bi-check-circle text-success mx-1"
              title="Submeter para aprovação"
              @click="submeterProva(row)"
            ></i>
            <i
              v-if="row.finalizada==='Sim'"
              class="bi bi-flag-fill text-success mx-1"
              title="Avaliação Finalizada"
              @click="abrirProvaFinalizada(row)"
            ></i>
            <i
              v-if="
                hasPermission('enviar_avaliacoes') &&
                row.finalizada === 'Sim' &&
                row.enviada === 'Sim' &&
                row.resposta_id
              "
              class="bi bi-envelope-arrow-up-fill text-primary mx-1"
              title="Reenviar avaliação por e-mail"
              @click="abrirReenvio(row)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <!-- 1. Resumo de registros -->
      <div>
        Mostrando {{ startRow }} a {{ endRow }} de {{ totalItems }} registros
      </div>

      <!-- 2. Seletor de itens por página -->
      <div class="d-flex align-items-center" style="gap: .5rem;">
        <b-form-select
          v-model="limitePorPagina"
          :options="pageOptions.map(n => ({ value: n, text: n + ' / página' }))"
          size="sm"
          style="width: 6rem"
          @change="alterarLimite"
        />
      </div>

      <!-- 3. Controle de página -->
      <div class="d-flex align-items-center">
        <b-pagination
          v-model="paginaAtual"
          :per-page="limitePorPagina"
          :total-rows="totalItems"
          size="sm"
          limit="5"
          @input="carregarAvaliacoes"
        />
      </div>
    </div>

    <!-- Modals -->
    <RealizarProva
      v-if="showModalRealizarProva"
      :avaliacaoId="selectedAvaliacao.id"
      :modoEdicao="modoEdicao"
      @close="closeModalRealizarProva"
      @salvou="refreshList"
    />

    <AvaliarProva
      v-if="showModalAvaliarProva"
      :avaliacaoId="selectedAvaliacao.id"
      :modoVisualizacao="modoVisualizacao"
      @close="showModalAvaliarProva = false"
      @salvou="handleAvaliacaoSalva"
    />

    <ProvaFinalizada
      v-if="showModalProvaFinalizada"
      :avaliacaoId="selectedAvaliacao.id"
      :modoVisualizacao="modoVisualizacao"
      @close="showModalProvaFinalizada = false"
    />

    <EmailAvaliacaoModal
      :show="showModalReenvio"
      :resposta-id="respostaIdReenvio"
      :modo-reenvio="true"
      @close="fecharReenvio"
      @enviado="avaliacaoReenviada"
    />
  </div>
</template>

<script>
import { reactive, getCurrentInstance } from 'vue';
import axios from '@/services/axios';
import { BButton, BPagination, BFormSelect } from 'bootstrap-vue-next';
import globalUtils from '@/utils/globalUtils.js';
import permissionMixin from '@/permissionMixin.js';
import RealizarProva from '@/components/modals/RealizarProva.vue';
import AvaliarProva from '@/components/modals/AvaliarProva.vue';
import ProvaFinalizada from '@/components/modals/ProvaFinalizada.vue';
import EmailAvaliacaoModal from '@/components/modals/EmailAvaliacaoModal.vue';

export default {
  name: 'ListarAvaliacoesDesempenho',

  mixins: [
    permissionMixin
  ],

  components: {
    BButton,
    BPagination,
    BFormSelect,
    RealizarProva,
    AvaliarProva,
    ProvaFinalizada,
    EmailAvaliacaoModal
  },
  data() {
    return {
      avaliacoesDesempenho: [],
      fields: [], // não usado no custom table
      filters: reactive({ avaliacao: '', aluno: '', instrutor: '', turma: '', vigencia: 'vigentes', realizacao: 'nao_realizadas' }),
      paginaAtual: 1,
      limitePorPagina: 10,
      totalPaginas: 1,
      totalItems: 0,             // <-- adicionado
      currentSort: reactive({ key: 'id', order: 'asc' }),
      showModalRealizarProva: false,
      showModalAvaliarProva: false,
      showModalProvaFinalizada: false,
      showModalReenvio: false,
      respostaIdReenvio: null,
      selectedAvaliacao: null,
      modoEdicao: false,
      modoVisualizacao: false,
      pageOptions: [10, 15, 20, 25, 50],
      vigenciaOptions: [
        { value: 'todas',     text: 'Todas (vigências)' },
        { value: 'vigentes',  text: 'Em vigência' },
        { value: 'anteriores',text: 'Anteriores' }
      ],
      realizacaoOptions: [
        { value: 'todas',          text: 'Todas (realização)' },
        { value: 'realizadas',     text: 'Finalizadas' },
        { value: 'nao_realizadas', text: 'Não finalizadas' },
        { value: 'analisar',       text: 'Analisar avaliação' }
      ]
    };
  },
  computed: {
    utils() { return globalUtils; },
    normalizedUserProfile() {
      const inst = getCurrentInstance();
      const up = localStorage.getItem('userProfile')
        || inst.appContext.config.globalProperties.$globalState.userProfile;
      return (up || '').trim().toLowerCase();
    },
    startRow() {   // <-- adicionado
      return (this.paginaAtual - 1) * this.limitePorPagina + 1;
    },
    endRow() {     // <-- adicionado
      return Math.min(this.paginaAtual * this.limitePorPagina, this.totalItems);
    }
  },

  watch: {
    paginaAtual(nv, ov) {
      if (nv !== ov) this.carregarAvaliacoes();
    },
    limitePorPagina(nv, ov) {
      if (nv !== ov) {
        this.paginaAtual = 1;
        this.carregarAvaliacoes();
      }
    }
  },


  methods: {
    async carregarAvaliacoes() {
      try {
        const res = await axios.get(
          `/cadastros/avaliacoes-periodos-provas/listagem`,
          { params: {
              page: this.paginaAtual,
              limit: this.limitePorPagina,
              avaliacao: this.filters.avaliacao || undefined,
              aluno:     this.filters.aluno     || undefined,
              instrutor: this.filters.instrutor || undefined,
              turma:     this.filters.turma     || undefined,
              vigencia:  this.filters.vigencia  || undefined,
              realizacao:this.filters.realizacao|| undefined,
            }}
        );
        const data = res.data;
        this.avaliacoesDesempenho = data.data;
        this.totalPaginas         = data.totalPages;
        // Ajuste: calcula totalItems provisoriamente
        this.totalItems =
          data.totalItems
          ?? data.total
          ?? (data.totalPages * this.limitePorPagina);
      } catch (e) {
        console.error('Erro ao carregar:', e);
      }
    },

    sort(col) {
      if (this.currentSort.key === col) {
        this.currentSort.order = this.currentSort.order === 'asc' ? 'desc' : 'asc';
      } else {
        this.currentSort.key = col;
        this.currentSort.order = 'asc';
      }
      this.carregarAvaliacoes();
    },
    arrow(col) {
      if (this.currentSort.key !== col) return '';
      return this.currentSort.order === 'asc' ? '▲' : '▼';
    },
    filtrarAvaliacoes() {
      this.paginaAtual = 1;
      this.carregarAvaliacoes();
    },
    limparFiltros() {
      Object.assign(this.filters, { avaliacao: '', aluno: '', instrutor: '', turma: '', vigencia: 'vigentes', realizacao: 'nao_realizadas' });
      this.carregarAvaliacoes();
    },
    paginaAnterior() {
      if (this.paginaAtual > 1) {
        this.paginaAtual--;
        this.carregarAvaliacoes();
      }
    },
    proximaPagina() {
      if (this.paginaAtual < this.totalPaginas) {
        this.paginaAtual++;
        this.carregarAvaliacoes();
      }
    },
    alterarLimite() {
      this.paginaAtual = 1;
      this.carregarAvaliacoes();
    },
    irParaCadastro() {
      this.$router.push('/cadastros/avaliacoes-periodos-provas/novo');
    },
    abrirRealizarProva(item) {
      this.selectedAvaliacao = item; this.modoEdicao = true; this.showModalRealizarProva = true;
    },
    closeModalRealizarProva() {
      this.showModalRealizarProva = false; this.selectedAvaliacao = null; this.modoEdicao = false;
    },
    abrirAvaliarProva(item) {
      this.selectedAvaliacao = item; this.modoVisualizacao = true; this.showModalAvaliarProva = true;
    },

    abrirReenvio(item) {
      if (!item.resposta_id) {
        this.$alert(
          'Não foi possível identificar a resposta desta avaliação.',
          'Atenção'
        );
        return;
      }

      this.respostaIdReenvio = item.resposta_id;
      this.showModalReenvio = true;
    },

    fecharReenvio() {
      this.showModalReenvio = false;
      this.respostaIdReenvio = null;
    },

    avaliacaoReenviada() {
      this.$toast.success('Avaliação reenviada com sucesso!');
      this.fecharReenvio();
      this.carregarAvaliacoes();
    },

    handleAvaliacaoSalva() {
      this.showModalAvaliarProva = false; this.carregarAvaliacoes();
    },
    abrirProvaFinalizada(item) {
      this.selectedAvaliacao = item; this.modoVisualizacao = true; this.showModalProvaFinalizada = true;
    },
    submeterProva(item) {
      this.$confirm('Deseja submeter a prova?','Confirmação').then(ok => {
        if (ok) axios.put(
          `/cadastros/avaliacoes-periodos-provas/submeter`,
          { id_avaliacao_periodo_prova: item.id }
        )
        .then(() => { this.$toast.success('Prova submetida!'); this.carregarAvaliacoes(); })
        .catch(() => this.$alert('Erro ao submeter para avaliação.'));
      });
    },
    refreshList() {
      this.carregarAvaliacoes();
    }
  },
  mounted() {
    this.carregarAvaliacoes();
  }
};
</script>

<style scoped>
:deep(.pagination.pagination-sm .page-link) {
  line-height: 1;
  font-size: 0.8rem !important;
  border-radius: 0 !important;
}
</style>





